import Tastet from '../tastet.js';

const CLASSES = {
  IS_STUCK: 'is-stuck',
};

export default class Sticky extends Tastet.View {
  // init ------------------------------------------------------------------------------------------------------------
  init($el, data) {
    data = this.set(data || {}, {
      ratio: 1,
      threshold: [1],
    });

    var observer = new IntersectionObserver(this.observer_onObserve.bind(this), {
      threshold: data.threshold,
      rootMargin: '-1px 0px 0px 0px',
    });

    var el = $el.get(0);
    if (el) {
      observer.observe(el);
    }
  }

  // private ---------------------------------------------------------------------------------------------------------

  // events ----------------------------------------------------------------------------------------------------------
  observer_onObserve(e) {
    e = e[0];

    if (e.intersectionRatio < this.data.ratio) {
      this.$element.addClass(CLASSES.IS_STUCK);
    } else {
      this.$element.removeClass(CLASSES.IS_STUCK);
    }
  }
}
